import { useTranslation } from "react-i18next";
import { Loader, Select, type SelectProps } from "@mantine/core";

import { useProductCategories } from "../../hooks/productCategories";
import { useSearchInput } from "../../hooks/searchInput";

export interface SelectProductCategoryProps extends Partial<Omit<SelectProps, "value" | "onChange">> {
    label?: string;
    placeholder?: string;
    value?: { key: string };
    onChange?(productCategory: { key: string });
}

export const SelectProductCategory = ({ label, placeholder, value, onChange, ...rest }: SelectProductCategoryProps) => {
    const { t } = useTranslation(["common"]);

    const { actualSearchExpression, setSearchExpression } = useSearchInput();
    const { productCategories, isLoadingProductCategories } = useProductCategories();

    return (
        <Select
            {...rest}
            label={label || t("productcategory")}
            placeholder={placeholder || t("productcategory_select")}
            nothingFound={t("nothing_found")}
            searchValue={actualSearchExpression}
            icon={isLoadingProductCategories && <Loader size="sm" />}
            data={productCategories.map((productCategory) => {
                return {
                    value: productCategory?.key,
                    label: productCategory?.name,
                };
            })}
            value={value?.key}
            onChange={(value) => {
                const productCategoryKey = productCategories.find(
                    (productCategory) => productCategory?.key === value
                )?.key;

                if (!productCategoryKey) {
                    return;
                }

                onChange?.({ key: productCategoryKey });
            }}
            onSearchChange={setSearchExpression}
            searchable
        />
    );
};
